// ------------------------------------
// Collapse
// ------------------------------------

initCollapses();

function initCollapses() {
  // Listas
  const $collapses = $('.collapse').not('.lp-opcoes-collapse').not('.payment-accordion');

  // Percorre todas as listas
  $collapses.each(function () {
    // Variáveis
    const $collapse = $(this);
    const $itens = $collapse.children('.collapse-item');
    const $itensTitle = $itens.children('.collapse-title');
    const $itensContent = $itens.children('.collapse-content');

    // Evento de click no título do item
    $itensTitle.on('click', function (ev) {
      ev.preventDefault();
      const $item = $(this).parent('.collapse-item');
      const $content = $(this).next('.collapse-content');
      if (!$item.hasClass('active')) {
        // Accordion
        if ($collapse.hasClass('accordion')) {
          disableAll($itens, $itensContent);
        }
        activeItem($item, $content);
      } else {
        disableItem($item, $content);
      }
    });
  });

  // Habilita um item
  function activeItem($item, $content) {
    $item.addClass('active');
    $content.slideDown();
  }

  // Desabilita um item
  function disableItem($item, $content) {
    $item.removeClass('active');
    $content.slideUp();
  }

  // Desabilita todos os itens
  function disableAll($itens, $contents) {
    $itens.removeClass('active');
    $contents.slideUp();
  }
}
